import styled from "styled-components";

export const Heading = styled.div`
  text-align: center;
  color: #000;
  font-family: Poppins;
  font-size: 1.125em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 2.13em;
`;
export const Input = styled.input`
  width: 15.4375rem;
  height: 2.5rem;
  border-radius: 0.5em;
  border: 1px solid #8e8e8e;
  background: #fff;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0.5em 0.94em;
  ::placeholder {
    color: #c8c8c8;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.69em;
`;
export const SocialIcon = styled.img`
  width: 2em;
  height: 2em;
  margin-right: 1.94em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-right: 1em;
  }
`;
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 14em;
  overflow-y: auto;
  padding-top: 7em;
  ::-webkit-scrollbar {
    width: 0em;
  }
`;
export const SubmitContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 5.1875rem;
  background: #f2f9ff;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0em 0em 0.5em 0.5em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 0em 2.5em;
  }
`;
export const Info = styled.div`
  color: #666;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 2.19em;
`;
